const BSC_CHAINLINK_MAPPING = {
  '0x2d5Fc41d1365fFe13d03d91E82e04Ca878D69f4B': {
    from: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xa767f745331D267c7751297D982b050c93985627': {
    from: '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x3334bF7ec892Ca03D1378B51769b7782EAF318C4': {
    from: '0xAD6cAEb32CD2c308980a548bD0Bc5AA4306c6c18',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x2a548935a323Bb7329a5E3F1667B979f16Bc890b': {
    from: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x43d80f616DAf0b0B42a928EeD32147dC59027D41': {
    from: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE': {
    from: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x116EeB23384451C78ed366D4f67D5AD44eE771A0': {
    from: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x264990fbd0A4796A3E3d8E37C4d5F87a3aCa5Ebf': {
    from: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x87Ea38c9F24264Ec1Fff41B04ec94a97Caf99941': {
    from: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xcBb98864Ef56E9042e7d2efef76141f15731B82f': {
    from: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x6f55DFAf098a813d87BB4e6392275b502360Bb9D': {
    from: '0xd4CB328A82bDf5f03eB737f37Fa6B370aef3e888',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x8EC213E7191488C7873cEC6daC8e97cdbAdb7B35': {
    from: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x132d3C0B1D2cEa0BC552588063bdBb210FDeecfA': {
    from: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xBA8683E9c3B1455bE6e18E7768e8cAD95Eb5eD49': {
    from: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xC333eb0086309a16aa7c8308DfD32c8BBA0a2592': {
    from: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xed93F3764334788f2f6628b30e505fe1fc5d1D7b': {
    from: '0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x63D407F32Aa72E63C7209ce1c2F5dA40b3AaE726': {
    from: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x9ef1B8c0E4F7dc8bF5719Ea496883DC6401d5b2e': {
    from: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xB38722F6A608646a538E882Ee9972D15c86Fc597': {
    from: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xca236E327F629f9Fc2c30A4E95775EbF0B89fac8': {
    from: '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x4e5a43A79f53c0a8e83489648Ea7e429278f8b2D': {
    from: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x74E72F37A8c415c8f1a98Ed42E78Ff997435791D': {
    from: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xE188A9875af525d25334d75F3327863B2b8cd0F1': {
    from: '0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xb57f259E7C24e56a1dA00F66b55A5640d9f9E7e4': {
    from: '0xBf5140A22578168FD562DCcF235E5D43A02ce9B1',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x45f86CA2A8BC9EBD757225B19a1A0D7051bE46Db': {
    from: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x51597f405303C4377E36123cBc172b13269EA163': {
    from: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xD5c40f5144848Bd4EF08a9605d860e727b991513': {
    from: '0x55d398326f99059fF775485246999027B3197955',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xB97Ad0E74fa7d920791E90258A6E2085088b4320': {
    from: '0x55d398326f99059fF775485246999027B3197955',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x798A65D349B2B5E6645695912880b54dfFd79074': {
    from: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0x93A67D414896A280bF8FFB3b389fE3686E014fda': {
    from: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0x8264d6983B219be65C4D62f1c82B3A2999944cF2': {
    from: '0x16939ef78684453bfDFb47825F8a5F714f12623a',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  '0xBF63F430A79D4036A5900C19818aFf1fa710f206': {
    from: '0xcF6BB5389c92Bdda8a3747Ddb454cB7a64626C63',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  '0xF841761481DF19831cCC851A54D8350aE6022583': {
    from: '0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e',
    to: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // yfi-usd
  '0xD7eAa5Bf3013A96e3d515c055Dbd98DbdC8c620D': {
    from: '0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // coin-usd
  '0x2d1AB79D059e21aE519d88F978cAF39d74E31AEB': {
    from: '0x87b008E57F640D94Ee44Fd893F0323AF933F9195',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ramp-usd
  '0xD1225da5FC21d17CaE526ee4b6464787c6A71b4C': {
    from: '0x8519EA49c997f50cefFa444d240fB655e89248Aa',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // vai-usd
  '0x058316f8Bb13aCD442ee7A216C7b60CFB4Ea1B53': {
    from: '0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ont-usd
  '0x887f177CBED2cf555a64e7bF125E1825EB69dB82': {
    from: '0xFd7B3A77848f1C2D67E05E54d78d174a0C850335',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // fil-usd
  '0xE5dbFD9003bFf9dF5feB2f4F445Ca00fb121fb83': {
    from: '0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ice-usd
  // '': {
  //     from: '0xf16e81dce15B08F326220742020379B855B87DF9',
  //     to: '0x0000000000000000000000000000000000000001',
  //     decimals: 8,
  //     fromDecimals: 18,
  //     toDecimals: 8
  // }
  // doge-usd
  '0x3AB0A0d137D4F946fBB19eecc6e92E64660231C8': {
    from: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // eos-usd
  '0xd5508c8Ffdb8F15cE336e629fD4ca9AdB48f50F0': {
    from: '0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // xtz-usd
  '0x9A18137ADCF7b05f033ad26968Ed5a9cf0Bf8E6b': {
    from: '0x16939ef78684453bfDFb47825F8a5F714f12623a',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // cake-usd
  '0xB6064eD41d4f67e353768aA239cA86f4F73665a1': {
    from: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
}

export default BSC_CHAINLINK_MAPPING
